<template lang="pug">
#safety-confirm-register(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span 安否確認の新規作成

    .box-body.register-body
      .note
        span 安否確認の実施時にタイトルを新規作成してください。
        br
        span 登録後に「施設関係者への安否確認」と「家族への情報提供」が出来ます。
      FormInput(
        key-name="タイトル"
        required
        name="name"
        v-model="name"
        type="text"
        placeholder="タイトル"
        :maxlength="32"
        :validation-rules="{ required: true, max: 32 }"
        :styles="{ width: '340px' }")

    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons
        button.btn.register-btn(@click="showConfirmRegisterModal" type="button") 登録
        button.btn.cancel-btn(@click="gotoSafetyConfirmList" type="button") キャンセル

  OkCancelModal(v-model="showRegisterModal" title="安否確認のタイトルを登録しますか？" @ok="registerSafetyConfirm")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoSafetyConfirmList")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";
import SafetyConfirmsService, { SafetyConfirmsPostModel } from "@/commons/services/SafetyConfirms";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";

/**
 * ### 安否確認登録画面コンポーネント
 */
@Component({
  components: {
    FormInput,
    PageLoading,
    ValidationAlert,
    OkCancelModal,
    OkModal
  },
  $_veeValidate: { validator: "new" }
})
export default class SafetyConfirmRegister extends Vue {
  /** 安否確認サービス */
  @Inject("SafetyConfirmsService") safetyConfirmsService!: SafetyConfirmsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 安否確認名 */
  name: string = "";

  /**
   * ### 登録確認ダイアログを表示する
   *
   * - バリデーションを実施する
   * - エラーでなければ確認ダイアログを表示する
   */
  public async showConfirmRegisterModal(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();

    if (validationResult) {
      this.showValidationAlert = false;
      this.showRegisterModal = true;
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### 安否確認を登録する
   *
   * - ローディングを表示
   * - 安否確認サービスを使用して安否確認を登録する
   * - 例外が無ければ成功ダイアログを表示する
   */
  public async registerSafetyConfirm(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    const requestBody: SafetyConfirmsPostModel = this.createRequestBody();
    await this.safetyConfirmsService.post(userStore, requestBody);

    // 登録成功ダイアログを表示する
    this.showRegisterSuccessModal = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### 安否確認登録リクエストボディ作成
   */
  public createRequestBody(): SafetyConfirmsPostModel {
    const requestBody: SafetyConfirmsPostModel = {
      name: this.$stringUtil.convertYen(this.name)
    };

    return requestBody;
  }

  /**
   * ### 安否確認一覧画面に遷移する
   */
  public gotoSafetyConfirmList(): void {
    this.$router.push(PcUrl.SafetyConfirmList);

    return;
  }
}
</script>

<style lang="scss" scoped>
#safety-confirm-register {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;

  .note {
    margin: 0 20px 20px 20px;
  }
  .register-btn,
  .cancel-btn {
    width: 120px;
  }
}
</style>
